export default "__VITE_ASSET__BlmpB9vO__"